import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
/* eslint-disable */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { utilCookies } from '@/util/cookies';
import axios from 'axios';
import loadLangPack from './loadLangPack';
export var langList = [{
  key: 'zh',
  label: '中文'
}, {
  key: 'en',
  label: 'English'
}, {
  key: 'th',
  label: 'ภาษาไทย'
}, {
  key: 'id',
  label: 'Bahasa Indonesia'
}];
var Lang = /*#__PURE__*/function () {
  function Lang() {
    _classCallCheck(this, Lang);
    Vue.use(VueI18n);
    this.init();
  }
  _createClass(Lang, [{
    key: "init",
    value: function init() {
      var _this = this;
      // 默认语言
      this.defaultLang = 'en';
      // 语言列表
      this.langList = langList;
      // 当前语言
      this.currentLang = this.getLanguage();
      this.curLang = this.langList.filter(function (item) {
        return item.key === _this.currentLang;
      })[0];
      // elementUI语言包
      this.language = new Map([['en', function () {
        return import('./en');
      }], ['zh', function () {
        return import('./zh');
      }], ['th', function () {
        return import('./th');
      }], ['id', function () {
        return import('./id');
      }]]);
      this.t = this.fun;
      // 返回I18n给第三方用
      this.i18n = new VueI18n({
        locale: this.currentLang,
        silentTranslationWarn: true
      });
      this.loadLanguage();
      utilCookies.setLanguage(this.currentLang);
    }
    // 获取当前语言环境
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      var lang = utilCookies.getLanguage() || localStorage.getItem('language');
      var localLanguage = lang ? lang.slice(0, 2) : false;
      if (localLanguage) return localLanguage;
      return this.defaultLang;
    }
    // 获取远程语言包
  }, {
    key: "getlang",
    value: function getlang() {
      var _this2 = this;
      var lang = window.lang || false;
      if (lang) return true;
      return loadLangPack(this.currentLang).then(function () {
        Vue.prototype.$t = _this2.fun;
      });
    }
    // 获取字段翻译
  }, {
    key: "fun",
    value: function fun(key, obj) {
      var res = window.lang.get(key);
      if (!res) {
        res = key;
        // console.warn(` "${key}" 字典不存在！`)
        return res;
      }
      if (obj) for (var k in obj) res = res.replace(new RegExp('{' + k + '}', 'g'), obj[k]);
      return res;
    }
    // 加载第三方语言包配置
  }, {
    key: "loadLanguage",
    value: function () {
      var _loadLanguage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var langFun;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              //设置i18n的默认语言
              axios.defaults.headers.common['Accept-Language'] = this.currentLang; //设置ajax请求的语言
              document.querySelector('html').setAttribute('lang', this.currentLang); //设置html的语言
              langFun = this.language.get(this.currentLang);
              _context.t0 = this.i18n;
              _context.t1 = this.currentLang;
              if (!langFun) {
                _context.next = 11;
                break;
              }
              _context.next = 8;
              return langFun();
            case 8:
              _context.t2 = _context.sent.default;
              _context.next = 12;
              break;
            case 11:
              _context.t2 = {};
            case 12:
              _context.t3 = _context.t2;
              _context.t0.setLocaleMessage.call(_context.t0, _context.t1, _context.t3);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadLanguage() {
        return _loadLanguage.apply(this, arguments);
      }
      return loadLanguage;
    }()
  }]);
  return Lang;
}(); // use see: src/store/modules/settings.js
export var lang = new Lang();
// use see: src/permission.js
export var getlang = lang.getlang.bind(lang);
export default lang.i18n;